import type {ReactElement} from 'react';
import React from 'react';
import {DropdownGhostSelectBox} from '@Components/dropdown-v2/components/dropdown-ghost-select-box';
import {DROPDOWN_SIZE} from '@Components/dropdown-v2/dropdown.types';
import styles from './base-size-dropdown-selector.module.scss';

interface BaseSizeDropdownSelectorProps {
  text: string;
  className?: string;
}

export function BaseSizeDropdownSelector({className = '', ...props}: BaseSizeDropdownSelectorProps): ReactElement {
  return <DropdownGhostSelectBox className={`${className} ${styles.selector}`} size={DROPDOWN_SIZE.SMALL} icon="icon-size" iconClassName={styles.icon} text={props.text} />;
}
